import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseDataService, HttpResponsesHandlersFactory } from "@bbwt/modules/data-service";
import { FormioHTMLData } from "@main/formio/components/formio-pdf/formio-pdf-generator.component";

@Injectable(
    { providedIn: "root" }
)
export class FormioPDFGeneratorService extends BaseDataService {
    readonly url = "api/formio-pdf-converter";
    
    constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
        super(http, handlersFactory);
    }

    generateFromFormio(data: FormioHTMLData): Promise<Blob> {
        return this.handle(this.http.post(`${this.url}/html-to-pdf`, data, { responseType: "blob" }));
    }
    
}